/**
 @ngdoc directive
 @name communicationTile

 @description
Tile that displays communication message

 @usage
 <communication-tile ng-repeat="tileModel in ctrl.filteredDataList()
                     | paginationStartFromFilter: ctrl.startFrom()
                     | limitTo: ctrl.pageSize
                     | orderBy: ctrl.orderBy:true
                     track by $index"
                     tile-model="tileModel"
                     common-label="ctrl.dataResponse.data.labels.common"
                     object-label="ctrl.dataResponse.data.labels.commsManagement"
                     name-list-grouped-by-xms-login-id="ctrl.dataResponse.data.nameListGroupedByXmsLoginId" />

 @param {data array}  tileModel                    - (passing tile model)parameter used to communication between communicationTile & communicationList directives
 @param {data array}  commonLabel                 - (passing common labels)parameter used to communication between communicationTile & communicationList directives
 @param {data array}  objectLabel                  - (passing object labels)parameter used to communication between communicationTile & communicationList directives
 @param {data array}  nameListGroupedByXmsLoginId  - (passing list of names by xms login id)parameter used to communication between communicationTile & communicationList directives

 */

(function() {
    'use strict';

    var communicationTile = function ($templateCache) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                //reminder [ '@':'one-way binding', '=':'two-way binding', '=?':'two-way binding optional', '&':'literal binding' ]
                tileModel: "=",
                commonLabel: "=",
                objectLabel: "=",
                nameListGroupedByXmsLoginId: "="
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/communicationTile.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;

                // Comms Management message status order for style classes
                var STATUS = {
                    POSITIVE: ["SENT"],
                    NEGATIVE: ["QUEUED_DELAYED"],
                    NEUTRAL:["SCHEDULED", "QUEUED"]
                };

                // Listing style classes based on recipient ID
                var RECIPIENT_CSS = {
                    92: "candidate",
                    5080: "manager",
                    93: "client",
                    3: "person"
                };

                //Applying style classes to different group of statuses
                $scope.statusClass = function(status){
                    for (var i = 0; i < STATUS.POSITIVE.length; i++) {
                        if(status == STATUS.POSITIVE[i]){
                            return 'badge-success';
                        }
                    }

                    for (var i = 0; i < STATUS.NEGATIVE.length; i++) {
                        if(status == STATUS.NEGATIVE[i]){
                            return 'badge-danger';
                        }
                    }
                };

                //Function that assigns the right recipient css class based on recipient object
                $scope.getRecipientClass = function(recipientTypeID){
                    if (recipientTypeID){
                        return RECIPIENT_CSS[recipientTypeID];
                    }
                };

            }]
        };
    };
    communicationTile.$inject = ['$templateCache'];
    angular.module('app').directive('communicationTile', communicationTile);
}());